const flattenNodes = $el => {
  let nodes = []

  Array.from($el.childNodes,
    node => (node.childNodes && node.childNodes.length > 0) ? nodes.push(...flattenNodes(node)) : nodes.push(node))

  return nodes
}

const hasOnlyText = $el => {
  const childNodes = flattenNodes($el.get(0))

  return childNodes
    .filter(node => node.nodeName !== 'BR')
    .every(node => node.textContent !== '')
}

module.exports = {
  flattenNodes,
  hasOnlyText,
}
